module.exports = __webpack_public_path__ + "static/media/Tips-To-Scrap-Car-Removal.4a982b3b.jpg";